import React from 'react';
import { Modal, View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { BACKEND_URL } from '../../../../Config/Const';
import { colores } from '../../../../styles/variablesCss';

const Revalidate = ({ visible, onClose, email, code, setCode, error: propError, isLoading: propIsLoading, navigation, setError: propSetError, setIsLoading: propSetIsLoading }) => {


  const handleClose = (result = false) => {
    if (typeof onClose === 'function') {
      onClose(result);
      return;
    }

    if (navigation?.navigate) {
      navigation.navigate('');
    }
  };

  const verifyCode = async () => {
    if (typeof propSetError === 'function') propSetError(null);

    const trimmedEmail = typeof email === 'string' ? email.trim() : '';
    const trimmedCode = typeof code === 'string' ? code.trim() : '';

    if (!trimmedEmail || !trimmedCode) {
      if (typeof propSetError === 'function') propSetError('Ingresá tu email y el código');
      return;
    }

    try {
      if (typeof propSetIsLoading === 'function') propSetIsLoading(true);

      const response = await fetch(`${BACKEND_URL}/rest/usuarios/validar-mail?mail=${encodeURIComponent(trimmedEmail)}&cod=${encodeURIComponent(trimmedCode)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      const resultadoExitoso = data.dsResultado?.resultado?.[0]?.resultado;
      const mensaje = data.dsResultado?.resultado?.[0]?.mensaje;

      // Si el resultado es false, mostrar el mensaje y no continuar
      if (resultadoExitoso === false) {
        if (typeof propSetError === 'function') {
          propSetError(mensaje || 'Código inválido');
        }
        return;
      }

      // Si el resultado es true, cerrar el modal
      if (response.ok && resultadoExitoso === true) {
        setTimeout(() => {
          handleClose(true);
        }, 2000);
      } else {
        if (typeof propSetError === 'function') {
          propSetError(mensaje || 'Código inválido');
        }
      }
    } catch (error) {
      console.error('Error al verificar código:', error);
      if (typeof propSetError === 'function') propSetError('Error de conexión');
    } finally {
      if (typeof propSetIsLoading === 'function') propSetIsLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="slide"
      onRequestClose={() => handleClose(false)}
    >
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <View style={styles.container}>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => handleClose(false)}
            >
              <Text style={styles.closeButtonText}>×</Text>
            </TouchableOpacity>

            <Text style={styles.title}>Ingresá el código</Text>

            <Text style={styles.description}>
              Te enviamos un código de verificación a tu correo: {email}
            </Text>

            <TextInput
              style={styles.inputPill}
              placeholder="Ingresá el código"
              value={code}
              onChangeText={setCode}
              keyboardType="numeric"
              editable={!propIsLoading}
              placeholderTextColor="#A0A0A0"
            />

            {propError ? <Text style={styles.errorText}>{propError}</Text> : null}

            <TouchableOpacity
              style={styles.button}
              onPress={verifyCode}
              disabled={propIsLoading || !code}
            >
              <Text style={styles.buttonText}>
                {propIsLoading ? 'Verificando...' : 'Verificar'}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    width: '92%',
    maxWidth: 720,
  },
  container: {
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    right: -5,
    top: -18,
    padding: 10,
    zIndex: 10000,
    cursor: 'pointer',
  },
  closeButtonText: {
    fontSize: 24,
    color: colores.rojo || '#E31837',
    fontWeight: 'bold',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: colores.rojo || '#E31837',
  },
  description: {
    fontSize: 16,
    marginBottom: 15,
    textAlign: 'center',
    color: '#666',
  },
  inputPill: {
    height: 42,
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 21,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: '#E5E5E5',
    fontSize: 15,
    marginBottom: 15,
  },
  button: {
    backgroundColor: colores.rojo || '#E31837',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 6,
    alignItems: 'center',
    alignSelf: 'center',
    minWidth: 180,
  },
  buttonText: {
    color: 'white',
    fontSize: 18,
    fontWeight: '700',
  },
  errorText: {
    color: 'red',
    marginBottom: 10,
    textAlign: 'center',
  },
});

export default Revalidate;
